import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ModalSelectMaps from './modalTracker';

import { Row, Col } from 'antd';
import { EnvironmentOutlined, RightOutlined } from '@ant-design/icons';
import { LoadScript } from '@react-google-maps/api';

import { PageSpinner } from 'components/page-spinner';

import './style.scss';

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_APP_GOOGLE_API_KEY;
const libraries = ['places'];

function CoordinatePicker({ mapCoordinate, mapCoordinateSetter }) {
  const [selectMapVisible, setSelectMapVisible] = useState(false);

  return (
    <>
      <div className="map-toggle pd-margin-bottom-lg">
        <div className="ant-form-item-label">
          <label title="Pinpoint">Pinpoint</label>
        </div>
        <div
          className="ant-input"
          onClick={setSelectMapVisible.bind(this, true)}>
          <Row type="flex" align="middle">
            <Col lg={1}>
              <EnvironmentOutlined />
            </Col>
            <Col lg={{ span: 21, offset: 1 }} className="text-section">
              {mapCoordinate.lat && mapCoordinate.lng ? (
                <span>{mapCoordinate.address}</span>
              ) : (
                <span>Select location in the map</span>
              )}
            </Col>
            <Col lg={1}>
              <RightOutlined />
            </Col>
          </Row>
        </div>
      </div>
      <LoadScript
        googleMapsApiKey={GOOGLE_MAPS_API_KEY}
        libraries={libraries}
        loadingElement={<PageSpinner />}
      >
        {selectMapVisible && (
          <ModalSelectMaps
            visible={selectMapVisible}
            onOK={setSelectMapVisible.bind(this, false)}
            onCancel={setSelectMapVisible.bind(this, false)}
            defaultLocation={mapCoordinate}
            mapSetter={mapCoordinateSetter}
          />
        )}
      </LoadScript>
    </>
  );
}

CoordinatePicker.propTypes = {
  mapCoordinate: PropTypes.object,
  mapCoordinateSetter: PropTypes.func,
};

export default CoordinatePicker;
